<template>
  <div>
    <v-data-table
      disable-pagination
      hide-default-footer
      :headers="headers"
      sort-by="applicationDate"
      sort-desc
      :items="items"
      item-key="id"
      disable-filtering
      :item-class="() => (clickable ? 'clickable' : null)"
      @click:row="clickable ? $emit('row-click', $event) : null"
    >
      <template v-slot:item.student="{ item }">
        <PersonItem :value="item.student" small />
      </template>
      <template v-slot:item.applicationDate="{ item }">
        <DateValue :value="item.applicationDate" /> ({{ item.teacher.code }})
      </template>
      <template v-slot:item.decisionDate="{ item }">
        <DateValue :value="item.decisionDate" />
        <span v-if="item.principal"> ({{ item.principal.code }})</span>
      </template>
      <template v-slot:item.emailSent="{ item }">
        <v-simple-checkbox
          class="d-inline"
          :value="item.emailSent"
          :disabled="!editable"
          @click.stop="toggleEmail(item)"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.absences="{ item }">
        <v-chip-group column>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" color="error" small outlined>{{
                item.pendingCount
              }}</v-chip>
            </template>
            <span>offene</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" color="success" small outlined>{{
                item.excusedCount
              }}</v-chip>
            </template>
            <span>entschuldigt</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" color="danger" small outlined>{{
                item.unexcusedCount
              }}</v-chip>
            </template>
            <span>unentschuldigt</span>
          </v-tooltip>
        </v-chip-group>
      </template>
      <template v-slot:item.actions="{ item }">
        <ReportButton
          text
          @click.stop
          color="error"
          :parameters="{
            id: item.id,
          }"
          v-if="item.principal != null"
          resource="report/frequentabsencesdecision"
          >Entscheid</ReportButton
        >
        <ReportButton
          v-if="$_hasRole('justificationAdmin')"
          text
          color="info"
          @click.stop
          :parameters="{
            id: item.id,
          }"
          resource="report/frequentabsencesarchive"
          >Archiv</ReportButton
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import DateValue from "common/components/DateValue.vue";
import PersonItem from "common/components/PersonItem.vue";
import PersonName from "common/components/PersonName.vue";
import PortraitImage from "common/components/PortraitImage.vue";
import ReportButton from "@/components/ReportButton.vue";
import { comparePeople } from "common/utils/people.js";

import { defineComponent } from "vue";

export default defineComponent({
  components: {
    DateValue,
    PersonItem,
    PersonName,
    PortraitImage,
    ReportButton,
  },
  props: {
    items: [],
    clickable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Schüler/in",
          value: "student",
          sort: (a, b) => comparePeople(a, b),
        },
        {
          text: "gemeldet",
          value: "applicationDate",
        },
        {
          text: "Absenzen",
          value: "absences",
          sortable: false,
        },
        {
          text: "Entscheid AL",
          value: "resolution",
          sortable: false,
        },
        {
          text: "E-Mail-Versand",
          value: "emailSent",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    toggleEmail(item) {
      this.$emit("toggle-email", item);
    },
  },
  created() {},
});
</script>
